(function(){
  const q=(s,c=document)=>c.querySelector(s);
  const qa=(s,c=document)=>Array.from(c.querySelectorAll(s));

  function initHero(){
    qa('[data-cu-hero]').forEach(hero=>{
      const slides=qa('.cu-hero__slide',hero);
      const dots=qa('.cu-hero__dot',hero);
      if(slides.length<2) return;
      let index=0;
      let timer;
      const show=n=>{
        index=(n+slides.length)%slides.length;
        slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===index));
        dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===index));
      };
      const play=()=>{timer=window.setInterval(()=>show(index+1),Number(hero.dataset.interval||6000));};
      dots.forEach((dot,i)=>dot.addEventListener('click',()=>{window.clearInterval(timer);show(i);play();}));
      show(0);
      play();
    });
  }

  function initSort(){
    qa('[data-cu-sort]').forEach(select=>{
      select.addEventListener('change',()=>{
        const url=new URL(window.location.href);
        url.searchParams.set('sort_by',select.value);
        url.searchParams.delete('page');
        window.location.href=url.toString();
      });
    });
  }

  function defaultCollectionSort(){
    const wrap=q('[data-cu-collection]');
    if(!wrap) return;
    const url=new URL(window.location.href);
    if(!url.searchParams.has('sort_by')){
      url.searchParams.set('sort_by','created-descending');
      window.location.replace(url.toString());
    }
  }

  function initMobile(){
    qa('[data-cu-menu-toggle]').forEach(button=>button.addEventListener('click',()=>{
      const nav=q('.cu-nav');
      if(!nav) return;
      const open=nav.classList.toggle('is-open');
      if(open){
        nav.style.display='flex';
        nav.style.position='fixed';
        nav.style.top='76px';
        nav.style.left='0';
        nav.style.right='0';
        nav.style.background='#050505';
        nav.style.padding='22px';
        nav.style.flexDirection='column';
        nav.style.alignItems='flex-start';
      }else{
        nav.removeAttribute('style');
      }
    }));
  }

  document.addEventListener('DOMContentLoaded',()=>{
    initHero();
    defaultCollectionSort();
    initSort();
    initMobile();
  });
})();
